import type { CSSProperties, SyntheticEvent } from "react";
import i18n from "../util/i18n.ts";
import { MobileTooltip } from "./MobileTooltip.tsx";

export const NextPrevButtons = <T extends unknown>({
	currentItem,
	items,
	reverse,
	disabled,
	onChange,
	style,
	buttonClassName = "btn btn-light-bordered btn-xs",
}: {
	currentItem?: T;
	items: T[];
	reverse?: boolean;
	disabled?: boolean;
	onChange: (newItem: T) => void;
	style?: CSSProperties;
	buttonClassName?: string;
}) => {
	const index = currentItem === undefined ? -1 : items.indexOf(currentItem);

	type ButtonInfo = {
		disabled: boolean;
		onClick: (event: SyntheticEvent) => void;
	};

	const buttonInfo: [ButtonInfo, ButtonInfo] = [
		{
			disabled: disabled || index <= 0,
			onClick: (event) => {
				event.preventDefault();
				const newItem = items[index - 1];
				if (newItem !== undefined) {
					onChange(newItem);
				}
			},
		},
		{
			disabled: disabled || index >= items.length - 1,
			onClick: (event) => {
				event.preventDefault();
				const newItem = items[index + 1];
				if (newItem !== undefined) {
					onChange(newItem);
				}
			},
		},
	];

	// Seasons are displayed in reverse order in the dropdown, and "prev" should be "back in time"
	if (reverse) {
		buttonInfo.reverse();
	}
	const previousLabel = i18n.t("common.previous", {
		ns: "ui",
		defaultValue: "Previous",
	});
	const nextLabel = i18n.t("common.next", { ns: "ui", defaultValue: "Next" });

	return (
		<div className="btn-group" style={style}>
			<MobileTooltip title={previousLabel}>
				<button
					aria-label={previousLabel}
					className={`${buttonClassName} next-prev-button`}
					disabled={buttonInfo[0].disabled}
					onClick={buttonInfo[0].onClick}
					type="button"
				>
					<span className="glyphicon glyphicon-menu-left" />
				</button>
			</MobileTooltip>
			<MobileTooltip title={nextLabel}>
				<button
					aria-label={nextLabel}
					className={`${buttonClassName} next-prev-button`}
					disabled={buttonInfo[1].disabled}
					onClick={buttonInfo[1].onClick}
					type="button"
				>
					<span className="glyphicon glyphicon-menu-right" />
				</button>
			</MobileTooltip>
		</div>
	);
};
